export type CompanyTypesEnum = 'client' | 'competitor' | 'supplier' | 'media';

export enum CompanyQueryType {
  SUPPLIERS_ALL = 'suppliers',
  CLIENTS_ALL = 'all',
  CLIENTS_MY = 'my',
  CLIENTS_DEPARTMENT = 'department',
  CLIENTS_FREE_WITH_INVOICES = 'checks',
  CLIENTS_WITH_LEADS = 'lids',
  CLIENTS_FREE = 'free',
  CLIENTS_ON_FIRED_MANAGERS = 'fired',
  CLIENTS_TO_DETACH = 'detachment',
}

export type CompanyTypes = {
  [x in CompanyTypesEnum]: { label: string; value: string };
};
export const COMPANY_TYPE_INFOS: CompanyTypes = {
  client: { label: 'Клиент', value: 'isClient' },
  competitor: { label: 'Конкурент', value: 'isCompetitor' },
  supplier: { label: 'Поставщик', value: 'isSupplier' },
  media: { label: 'Рекламный носитель', value: 'isMedia' }
};
export const CompanyTypesList: [x: CompanyTypesEnum] = Object.keys(COMPANY_TYPE_INFOS) as [x: CompanyTypesEnum];

export enum DeleteLinkMessage {
  MANAGER_SELF_BLOCKED = 'manager_self_blocked',
  SUBORDINATE_BLOCKED = 'subordinate_blocked',
  LINK_DELETED = 'link_deleted'
}

export interface IDeleteManagerLinkResponse {
  message: DeleteLinkMessage;
  linkId: number;
}